import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  title: string;
  subtitle: string;
}
export function PageHero({
  title,
  subtitle
}: PageHeroProps) {
  return <section className="relative pt-32 pb-20 md:pt-44 md:pb-32 overflow-hidden bg-gradient-to-br from-primary to-primary-dark" data-id="element-230">
      {/* Background Texture & Orbs */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-231">
        {/* Dot Pattern */}
        <div className="absolute inset-0 opacity-[0.05]" data-id="element-232">
          <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" data-id="element-233">
            <defs data-id="element-234">
              <pattern id="hero-dots-page" width="24" height="24" patternUnits="userSpaceOnUse" data-id="element-235">
                <circle cx="2" cy="2" r="1" fill="white" data-id="element-236" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#hero-dots-page)" data-id="element-237" />
          </svg>
        </div>

        {/* Animated Orbs */}
        <motion.div animate={{
        x: [0, 50, 0],
        y: [0, -30, 0]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute -top-1/4 -right-1/4 w-[600px] h-[600px] rounded-full bg-white/10 blur-[100px]" data-id="element-238" />
        <motion.div animate={{
        x: [0, -40, 0],
        y: [0, 60, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute -bottom-1/4 -left-1/4 w-[500px] h-[500px] rounded-full bg-accent/20 blur-[100px]" data-id="element-239" />
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.1, 0.2, 0.1]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-primary-light/5 blur-[120px]" data-id="element-240" />
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-241">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6" data-id="element-242">
          {title}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-xl text-primary-100 text-white/90 max-w-2xl mx-auto" data-id="element-243">
          {subtitle}
        </motion.p>
      </div>
    </section>;
}